import { render, staticRenderFns } from "./ArbitrationServe.vue?vue&type=template&id=1ca02a84&"
import script from "./ArbitrationServe.vue?vue&type=script&lang=js&"
export * from "./ArbitrationServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports